import React from "react";
import { useNavigate } from "react-router-dom";

export default function ChatSidebar({
  conversations = [],
  conversationId,
  myUserId,
  onlineUsers = {},
  unreadCounts = {}
}) {
  const navigate = useNavigate();

  return (
    <div className="w-80 bg-white border-r overflow-y-auto">
      <h2 className="p-4 text-xl font-bold border-b bg-gray-50">Messages</h2>

      {conversations.map((c) => {
        const otherId =
          c.clientUserId === myUserId ? c.landlordUserId : c.clientUserId;

        const otherName =
          c.clientUserId === myUserId
            ? c.landlordUserName
            : c.clientUserName;

        const avatar =
          c.clientUserId === myUserId
            ? c.landlordProfileImageUrl
            : c.clientProfileImageUrl;

        const isActive = c.id === conversationId;
        const isOnline = !!onlineUsers[otherId];

        return (
          <div
            key={c.id}
            onClick={() => navigate(`/chat/${c.id}`)}
            className={`flex items-center gap-3 p-4 cursor-pointer border-b hover:bg-gray-100 ${
              isActive ? "bg-blue-50" : ""
            }`}
          >
            <div className="relative">
              <img
                src={avatar || "/default-avatar.png"}
                className="w-12 h-12 rounded-full object-cover"
                alt="avatar"
              />
              <span
                className={`absolute bottom-0 right-0 w-3 h-3 border border-white rounded-full ${
                  isOnline ? "bg-green-500" : "bg-gray-400"
                }`}
              />
            </div>

            <div className="flex-1">
              <div className="font-semibold truncate">{otherName}</div>
              <div className="text-sm text-gray-500 truncate">
                {c.roomName || "Annonce"}
              </div>
            </div>

            {unreadCounts[c.id] > 0 && (
              <span className="px-2 py-1 bg-red-600 text-white text-xs rounded-full">
                {unreadCounts[c.id]}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
